import { Patient } from './../../../../../core/utils/role';
import { PreAssesmentComponent } from '../pre-assesment/pre-assesment.component';
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AppoimentService } from '../appoinment-services/appoiment.service';
import { filter, switchMap, take, takeUntil, tap, timer } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'patient-pre-score',
  imports: [CommonModule],
  templateUrl: './pre-score.component.html',
  styleUrl: './pre-score.component.css',
})
export class PreScoreComponent {
  preAssessment: any;
  assessmentDetails: any;
  scoreData: any;

  scoreDataInput: any;

  @ViewChild(PreAssesmentComponent)
  preAssesment!: PreAssesmentComponent;

  private appointmentService = inject(AppoimentService);
  private router = inject(Router);

  isBookingAllowed: boolean = false;

  isLoading = true;

  ngOnInit() {
    const state = history.state;

    if (state?.assessmentDetails) {
      this.assessmentDetails = state.assessmentDetails;
      console.log('Assessment Data:', this.assessmentDetails);
      const patientId = this.assessmentDetails.patientID;
      const assessmentID = this.assessmentDetails.assessmentID;
      this.isBookingAllowed = this.assessmentDetails.isFromAppointment ; // Allow booking since we have assessment details
      this.getAssessmentScore(patientId, assessmentID);
    }
  }

  getAssessmentScore(PatientId: string, assessmentId: string) {
    const timeout$ = timer(60000); // 1 minute timeout

    timer(0, 3000) // call immediately, then every 3 sec
      .pipe(
        takeUntil(timeout$),
        switchMap(() => this.appointmentService.getAssessmentScore(assessmentId, PatientId)),
        tap((res: any) => console.log(res, 'score api')),
        filter((res: any) => res?.data?.json_data), // Wait until data exists
        take(1), // stop polling once data found
      )
      .subscribe({
        next: (res: any) => {
          if (res?.data?.json_data) {
            this.scoreDataInput = res;
            this.parseAndSetData(res); // Pass the whole response down
          }
          console.log('scoreDataInput in pre-assessment component :', this.scoreDataInput);
        },
        error: (err) => {
          console.warn(err);
          this.isLoading = false;
        },
        complete: () => {
          // If polling completes due to the 1-minute timeout without getting data, bypass directly to payment summary
          if (this.isLoading) {
            console.log('Timed out after 1 min. No score data received.');
            this.isLoading = false;
          }
        },
      });
  }

  private parseAndSetData(res: any) {
    try {
      const jsonData = res.data.json_data;

      // json_data may come as a string or already parsed object
      const parsed = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;

      this.preAssessment = parsed;
      this.scoreData = parsed.actual_pre_assessment_score;

      console.log('preAssessment:', this.preAssessment);
      console.log('scoreData:', this.scoreData);
    } catch (e) {
      console.warn('Failed to parse json_data:', e);
    } finally {
      this.isLoading = false; // always stop shimmer
    }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['scoreDataInput'] && this.scoreDataInput) {
  //     console.log('Received Data in Pre-Score:', this.scoreDataInput);

  //     let docData = null;

  //     // Handle Appwrite/API document array response
  //     if (Array.isArray(this.scoreDataInput) && this.scoreDataInput.length > 0) {
  //       docData = this.scoreDataInput[0];
  //     } else if (!Array.isArray(this.scoreDataInput) && Object.keys(this.scoreDataInput).length > 0) {
  //       docData = this.scoreDataInput; // Handle direct object response
  //     }

  //     // If we successfully identified the document data, process it and stop the shimmer
  //     if (docData) {
  //       // Handle new nested JSON structure
  //       if (docData.data && docData.data.json_data) {
  //         try {
  //           const parsedData = typeof docData.data.json_data === 'string'
  //               ? JSON.parse(docData.data.json_data)
  //               : docData.data.json_data;

  //           this.preAssessment = parsedData;
  //           this.scoreData = parsedData.actual_pre_assessment_score;
  //         } catch (e) {
  //           console.warn('Failed to parse data.json_data:', e);
  //           this.scoreData = null;
  //         }
  //       } else {
  //         // Handle old fallback structure
  //         this.preAssessment = docData;

  //         if (docData.actual_pre_assessment_score) {
  //           if (typeof docData.actual_pre_assessment_score === 'string') {
  //             try {
  //               this.scoreData = JSON.parse(docData.actual_pre_assessment_score);
  //             } catch (e) {
  //               console.warn('Failed to parse actual_pre_assessment_score property:', e);
  //               this.scoreData = docData.actual_pre_assessment_score;
  //             }
  //           } else {
  //             this.scoreData = docData.actual_pre_assessment_score;
  //           }
  //         } else {
  //           // Fallback if the whole doc is the score object itself
  //           this.scoreData = docData;
  //         }
  //       }

  //       // Stop the shimmer animation!
  //       this.isLoading = false;
  //     }
  //   }
  // }

  proceedToAppointment() {
    // this.proceedClicked.emit(true);
    this.router.navigateByUrl('schedule-appointment', {
      state: {
        assessmentDetails: this.assessmentDetails,
      },
    });
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }
}
